import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const palpitation: AnswerPathTreeNode = {
  path: 'palpitation',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredPalpitationsDetails }],
};
